import { render, staticRenderFns } from "./Confirmacao.vue?vue&type=template&id=3678875a&scoped=true&"
import script from "./Confirmacao.vue?vue&type=script&lang=js&"
export * from "./Confirmacao.vue?vue&type=script&lang=js&"
import style0 from "./Confirmacao.vue?vue&type=style&index=0&id=3678875a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678875a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VDatePicker,VExpandTransition,VIcon,VTextField})
